<template>
  <div class="testimonials-section">
    <!-- 头部区域 -->
    <div class="header">
      <div class="tag">CLIENT FEEDBACK</div>
      <h2 class="title">What Our <span class="gradient">Clients Say</span></h2>

      <!-- 居中带分割线的装饰 -->
      <div class="divider-container">
        <div class="line"></div>
        <span class="square-icon">[■]</span>
        <div class="line"></div>
      </div>
    </div>

    <!-- 卡片网格 -->
    <div class="grid">
      <div v-for="(client, index) in clients" :key="index" class="card">
        <div class="stars">★★★★★</div>
        <p class="content">{{ client.text }}</p>

        <!-- 底部客户信息 -->
        <div class="footer">
          <div class="user-info">
            <span class="flag">{{ client.flag }}</span>
            <div class="user-text">
              <div class="name">{{ client.name }}</div>
              <div class="location">{{ client.location }}</div>
            </div>
          </div>
          <div class="verified">
            <span class="check-icon">✓</span> VERIFIED
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Testimonials',
  data() {
    return {
      clients: [
        {
          flag: '🇺🇸',
          name: 'James Harrington',
          location: 'UNITED STATES · BTC RECOVERY',
          text: 'I lost over $45,000 to a fake crypto investment platform. Fraud Counsel traced every transaction and helped me file an enforcement case. Their process was thorough and professional from start to finish. I genuinely cannot thank them enough.'
        },
        {
          flag: '🇸🇬',
          name: 'David Tan Wei',
          location: 'SINGAPORE · USDT RECOVERY',
          text: 'Their blockchain intelligence tools tracked my stolen USDT across four different wallets and two exchanges. The team coordinated directly with the platforms and the recovery was completed within the week. Truly world-class service.'
        },
        {
          flag: '🇯🇵',
          name: 'Kenji Yamamoto',
          location: 'JAPAN · ETH RECOVERY',
          text: 'After a DeFi exploit took everything, Fraud Counsel analysed the smart contract, traced the developer wallets, and built a case that authorities were able to act on. Their understanding of DeFi fraud is comprehensive and highly specialised.'
        }
      ]
    };
  }
}
</script>

<style scoped>
.testimonials-section {
  background-color: #070b14;
  padding: 100px 5%;
  color: #fff;
}

/* 头部区域 */
.header {
  max-width: 1400px;
  margin: 0 auto 60px;
  text-align: left;
}

.tag {
  color: #00ff88;
  font-size: 0.85rem;
  letter-spacing: 2px;
  margin-bottom: 20px;
  text-transform: uppercase;
  font-weight: 600;
}

.title {
  font-size: 3.5rem;
  font-weight: 800;
  margin: 0 0 20px;
}

/* 渐变文字效果 */
.gradient {
  background: linear-gradient(90deg, #00ff88, #4fd1c5);
  -webkit-background-clip: text;
  color: transparent;
}

/* 分割线 */
.divider-container {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 10px;
}

.divider-container .line {
  flex: 1;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.15);
}

.divider-container .square-icon {
  color: #00ff88;
  font-size: 0.9rem;
  font-family: monospace;
  margin: 0 15px;
}

/* 网格布局 */
.grid {
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px;
}

/* 卡片样式 */
.card {
  background: rgba(13, 17, 23, 0.8);
  border: 1px solid rgba(37, 48, 69, 0.5);
  border-radius: 10px;
  padding: 35px 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: transform 0.3s, border-color 0.3s;
}

.card:hover {
  border-color: #00ff88;
  transform: translateY(-5px);
}

.stars {
  color: #ffd700;
  font-size: 1.2rem;
  letter-spacing: 2px;
  margin-bottom: 25px;
}

.content {
  color: #a0b3cc;
  font-size: 1.05rem;
  line-height: 1.8;
  margin: 0 0 30px;
  flex: 1;
  /* 让底部信息贴底 */
}

.footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.flag {
  font-size: 2rem;
}

.name {
  font-weight: 700;
  font-size: 1.2rem;
  color: #fff;
  margin-bottom: 5px;
}

.location {
  color: #a0b3cc;
  font-size: 0.85rem;
  letter-spacing: 1px;
}

.verified {
  color: #00ff88;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 5px;
}

.check-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 14px;
  height: 14px;
  border: 1px solid #00ff88;
  border-radius: 50%;
  font-size: 0.7rem;
}

/* 响应式适配 */
@media (max-width: 1200px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .title {
    font-size: 2.5rem;
  }

  .grid {
    grid-template-columns: 1fr;
  }
}
</style>